import {
	type MeProfileGetProfileImagePresignUrlMutationVariables,
	useMeProfileGetProfileImagePresignUrl,
} from '@cocoonspace/api'
import axios from 'axios'

export type ProfileImageKind =
	MeProfileGetProfileImagePresignUrlMutationVariables['kind']

export const useUploadProfileImage = () => {
	const { mutateAsync: getPresignUrl } = useMeProfileGetProfileImagePresignUrl()

	const uploadImage = async (blob: Blob, kind: ProfileImageKind) => {
		const { signedUrl, path } = await getPresignUrl({ kind })

		await axios.put(signedUrl, blob, {
			headers: { 'Content-Type': blob.type },
		})

		return path
	}

	return { uploadImage }
}
